// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumb-module--breadcrumbs--7250d";
export var current = "breadcrumb-module--current--62196";
export var currentArticle = "breadcrumb-module--current-article--70f42";
export var faChevronDown = "breadcrumb-module--fa-chevron-down--65e16";
export var fas = "breadcrumb-module--fas--a401f";
export var hasDropdown = "breadcrumb-module--has-dropdown--23e5b";
export var isDrop = "breadcrumb-module--is-drop--31f0d";
export var last = "breadcrumb-module--last--d1a93";
export var rubriek = "breadcrumb-module--rubriek--33aa5";